/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMetaMcpMembersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMetaMcpMembersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMetaMcpMembersSecurity = {
  option1?: ListMetaMcpMembersSecurityOption1 | undefined;
  option2?: ListMetaMcpMembersSecurityOption2 | undefined;
};

export type ListMetaMcpMembersRequest = {
  /**
   * The ID of the meta MCP server
   */
  metaMcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMetaMcpMembersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMetaMcpMembersSecurityOption1$outboundSchema: z.ZodMiniType<
  ListMetaMcpMembersSecurityOption1$Outbound,
  ListMetaMcpMembersSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMetaMcpMembersSecurityOption1ToJSON(
  listMetaMcpMembersSecurityOption1: ListMetaMcpMembersSecurityOption1,
): string {
  return JSON.stringify(
    ListMetaMcpMembersSecurityOption1$outboundSchema.parse(
      listMetaMcpMembersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMetaMcpMembersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMetaMcpMembersSecurityOption2$outboundSchema: z.ZodMiniType<
  ListMetaMcpMembersSecurityOption2$Outbound,
  ListMetaMcpMembersSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listMetaMcpMembersSecurityOption2ToJSON(
  listMetaMcpMembersSecurityOption2: ListMetaMcpMembersSecurityOption2,
): string {
  return JSON.stringify(
    ListMetaMcpMembersSecurityOption2$outboundSchema.parse(
      listMetaMcpMembersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMetaMcpMembersSecurity$Outbound = {
  Option1?: ListMetaMcpMembersSecurityOption1$Outbound | undefined;
  Option2?: ListMetaMcpMembersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMetaMcpMembersSecurity$outboundSchema: z.ZodMiniType<
  ListMetaMcpMembersSecurity$Outbound,
  ListMetaMcpMembersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMetaMcpMembersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMetaMcpMembersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMetaMcpMembersSecurityToJSON(
  listMetaMcpMembersSecurity: ListMetaMcpMembersSecurity,
): string {
  return JSON.stringify(
    ListMetaMcpMembersSecurity$outboundSchema.parse(listMetaMcpMembersSecurity),
  );
}

/** @internal */
export type ListMetaMcpMembersRequest$Outbound = {
  meta_mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMetaMcpMembersRequest$outboundSchema: z.ZodMiniType<
  ListMetaMcpMembersRequest$Outbound,
  ListMetaMcpMembersRequest
> = z.pipe(
  z.object({
    metaMcpServerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      metaMcpServerId: "meta_mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMetaMcpMembersRequestToJSON(
  listMetaMcpMembersRequest: ListMetaMcpMembersRequest,
): string {
  return JSON.stringify(
    ListMetaMcpMembersRequest$outboundSchema.parse(listMetaMcpMembersRequest),
  );
}
